import React from 'react';

import { IIconProps } from '@icons/interface';

import colors from '@constants/colors';

const UploadFileIcon = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='26'
			viewBox='0 0 22 26'
			width='22'
		>
			<path
				d='M21.043 7.64454L14.4805 1.08205C14.3019 0.907931 14.0619 0.811109 13.8125 0.812515H2.5625C2.06522 0.812515 1.58831 1.01006 1.23667 1.36169C0.885044 1.71332 0.6875 2.19023 0.6875 2.68751V23.3125C0.6875 23.8098 0.885044 24.2867 1.23667 24.6383C1.58831 24.99 2.06522 25.1875 2.5625 25.1875H19.4375C19.9348 25.1875 20.4117 24.99 20.7633 24.6383C21.115 24.2867 21.3125 23.8098 21.3125 23.3125V8.31251C21.3139 8.06309 21.2171 7.82314 21.043 7.64454ZM14.9492 16.9492L11.668 20.2305C11.4888 20.4037 11.2493 20.5006 11 20.5006C10.7507 20.5006 10.5112 20.4037 10.332 20.2305L7.05078 16.9492C6.90129 16.7671 6.82489 16.5358 6.83645 16.3005C6.84801 16.0651 6.9467 15.8425 7.11332 15.6758C7.27995 15.5092 7.5026 15.4105 7.73796 15.399C7.97332 15.3874 8.20457 15.4638 8.38672 15.6133L10.0625 17.3008V12.0625C10.0625 11.8139 10.1613 11.5754 10.3371 11.3996C10.5129 11.2238 10.7514 11.125 11 11.125C11.2486 11.125 11.4871 11.2238 11.6629 11.3996C11.8387 11.5754 11.9375 11.8139 11.9375 12.0625V17.3008L13.6133 15.6133C13.7954 15.4638 14.0267 15.3874 14.262 15.399C14.4974 15.4105 14.7201 15.5092 14.8867 15.6758C15.0533 15.8425 15.152 16.0651 15.1636 16.3005C15.1751 16.5358 15.0987 16.7671 14.9492 16.9492ZM13.8125 8.31251V3.15626L18.9688 8.31251H13.8125Z'
				fill={props?.color || colors.indigo50}
			/>
		</svg>
	);
};

export default UploadFileIcon;
